import { FC, ReactNode } from 'react'
import { Tooltip } from '@pepper/ui'

import StagePill from 'components/StagePill/StagePill'

import styles from './_.module.css'

interface Details {
  title: string
  value: string | ReactNode
}

interface Props {
  details: Details[]
  tagData?: Assignment
}

const DisplayDetails: FC<Props> = ({ details, tagData }) => {
  return (
    <div className={styles.wrapper}>
      {tagData?.stage && (
        <div className={styles.item}>
          <StagePill stage={tagData.stage} />
        </div>
      )}
      <div className={styles.item}>
        {details.map(detail => {
          if (
            detail.title !== 'Word Count' &&
            Object.values(detail)[1].props?.children === '-'
          ) {
            return (
              <div className={styles.details} key={detail.title}>
                <span className={styles.detailsTitle}>{detail.title}:</span>
                <Tooltip
                  placement="bottom"
                  overlayClassName={styles.tooltip}
                  title="Deadline will be updated once the creator is assigned"
                >
                  <div className={styles.detailsValue}>
                    Estimation in progress
                  </div>
                </Tooltip>
              </div>
            )
          }

          return (
            <div className={styles.details} key={detail.title}>
              <span className={styles.detailsTitle}>{detail.title}:</span>
              <div className={styles.detailsValue}>{detail.value}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DisplayDetails
